import type { TOC } from '@ember/component/template-only';

const SettingsLevelPartnerRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default SettingsLevelPartnerRouteTemplate;
